import { render, staticRenderFns } from "./CamaraEnVivoOperacionesPantalla.vue?vue&type=template&id=18b38c40&scoped=true&"
import script from "./CamaraEnVivoOperacionesPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraEnVivoOperacionesPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraEnVivoOperacionesPantalla.vue?vue&type=style&index=0&id=18b38c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b38c40",
  null
  
)

export default component.exports